import axios from "axios";

const inovaone_api_integracoes = axios.create({
  baseURL: "https://api.inovacode.app.br/",
});

// Autenticação lida do localStorage a cada requisição, igual ao inovaone_api.
//
// As rotas de ERP externo (/nater/rota, /bstories/rota, ...) passam pelo
// `authenticate` da API; só /inovaone/rota é aberta. Sem estes cabeçalhos a
// importação de pedido respondia 401 "No token!" e o interceptor abaixo
// derrubava o usuário para o login.
//
// O id_conta não é opcional: o `authenticate` compara o cabeçalho com o id do
// token e responde 400 "Not allowed!" quando divergem.
inovaone_api_integracoes.interceptors.request.use((config) => {
  const access_token = localStorage.getItem("access_token");
  if (access_token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${access_token}`;
  }

  if (!config.headers["id_conta"]) {
    const usuario_local_info = localStorage.getItem("usuario_local_info");
    if (usuario_local_info) {
      try {
        const { id_conta } = JSON.parse(usuario_local_info);
        if (id_conta) config.headers["id_conta"] = id_conta;
      } catch {
        // informação corrompida no storage: segue sem o cabeçalho
      }
    }
  }

  return config;
});

inovaone_api_integracoes.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("usuario_local_info");
      document.location.href = "/auth";
    }
    return Promise.reject(error);
  },
);

export default inovaone_api_integracoes;
